var map = {
	"./Australia.png": "c86d",
	"./Austria.png": "619d",
	"./Belarus.png": "7633",
	"./Belgium.png": "d042",
	"./China.png": "807d",
	"./Croatia.png": "7cdc",
	"./Czech_Republic.png": "ea30",
	"./France.png": "89d5",
	"./Greece.png": "5bed",
	"./Italy.png": "abe9",
	"./Japan.png": "ae21",
	"./Latvia.png": "ebb5",
	"./Luxembourg.png": "9912",
	"./Poland.png": "2b95",
	"./Russia.png": "8bd9",
	"./Spain.png": "e817",
	"./Switzerland.png": "8a84",
	"./Tunisia.png": "c76f",
	"./USA.png": "07bf",
	"./Ukraine.png": "1023",
	"./United_Kingdom.png": "bbbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "757f";